import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from "../../assets/logo.svg"
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaGlobe, FaEnvelope } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FooterDark = () => {
  return (
    <div className="">
      <footer>
        <ToastContainer />
        <div className="footer-container ">
          <div className="footer-section">
            <div className="brand-min">
              {/* <img src={logo} alt="ConRa Logo" className="brand-logo" /> */}
              <h2>ConRa is available for all devices</h2>
            </div>
            <p className="footer-text">
              Building trust through real-time verification
            </p>
          </div>

          <div className="foot-buttons">
            <a href="https://apps.apple.com/us/app/conra-smart-construction/id6762303075" target="_blank" rel="noopener noreferrer">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                className="store-button" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.conra_mobile.app" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="store-button" />
            </a>
          </div>
        </div>
        <div className="footer-container footer-bottom">
          <p>&copy; 2025 All Rights Reserved</p>
          <div className="footer-socials">
            <span><FaGlobe /> English (US)</span>
            <span><a href="https://www.facebook.com/" target="_blank" className="social-icon"><FaFacebookF /></a></span>
            <span><a href="https://www.linkedin.com/" target="_blank" className="social-icon"><FaLinkedinIn /></a></span>
            <span><a href="https://x.com/" target="_blank" className="social-icon"><FaTwitter /></a></span>
            <span><a href="https://www.youtube.com/" target="_blank" className="social-icon"><FaYoutube /></a></span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterDark;
